import React from 'react'

const Button = ({children, back, ...props}) => {
  return (
    <button {...props}  className={`button ${back ? 'button-back text-black border' : 'text-white border-0'}`}>
        {children}
    </button>
  )
}

export default Button